import React from 'react';
import styles from '../../styles/pages/Editor.module.css';

const Output = () => {
  return (
    <div className={styles.left} style={{ paddingBottom: '80px' }}>
      <h2>Output</h2>
    </div>
  );
};

export default Output;
